
import React from "react";


const Card = ({
    heading,
    children,
    CardHeaderClass = "card-header fw-semibold",
    CardRowClass = "row g-3 pb-3",
    theme = "",
    isRow = true
}) => {

    return (
        <>
            <div className={`card ${theme} `}>
                {
                    heading && (
                        <div className={CardHeaderClass}>{heading}</div>
                    )
                }
                {
                    children && (
                        <div className="card-body">
                            {
                                isRow ? <div className={CardRowClass}>
                                    {children}
                                </div> :  children 
                            }

                        </div>
                    )
                }
            </div>
        </>
    )
}

export default Card;